import NDRIcon from "@assets/ndr2025/ndr-title-icon.gif";
import { NDR_2025_PAGE } from "@config/ndr2025";
import Heading from "@elements/Typography/Heading";
import BHBasePage, { type BHBasePageProps } from "@pages/BHBasePage";
import ErrorPage from "@pages/ErrorPage";
import WidgetWrapper from "@pages/Home/HomePageLayout/WidgetWrapper";
import NotFound from "@pages/NotFound";
import type { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import {
  CustomContext,
  ResponseType,
  useRouteContext,
} from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import LiveBlog from "./Components/LiveBlog";
import SeasonalKeywordArticleList from "./Components/SeasonalKeywordArticleList";
import { GEPayloadResponseType } from "./SeasonalTags.server";
import SeasonalTagsMetaData from "./SeasonalTagsMetaData";

export function SeasonalTags() {
  const routeContext: CustomContext<
    TRouteWithoutRedirect<GEPayloadResponseType, string>
  > = useRouteContext();
  const dataLoaderResponse = routeContext.context;

  if (dataLoaderResponse.type === ResponseType.CLIENT_ERROR) {
    return <NotFound />;
  } else if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  const { tagsData, geLiveBlog } = dataLoaderResponse.payload;

  const adsSectionName = NDR_2025_PAGE;
  const { gaData, metaTags } = SeasonalTagsMetaData(adsSectionName);
  const pageAdTargetValue = PageAdTargetingTypeEnum.LISTING;

  const basePageProps: BHBasePageProps = {
    uniqueSectionName: adsSectionName,
    gaData: gaData,
    metaTags: metaTags,
    pageAdTargetValue: pageAdTargetValue,
    hasLb1Ads: true,
    showGEBanner: false,
    bodyWrapperStyle: "my-0 lg:my-0 py-3 lg:py-md",
  };

  return (
    <BHBasePage {...basePageProps}>
      <WidgetWrapper>
        <div>
          <div className="border-b-[1px] border-grey-400 pb-[10px] md:pb-[20px] mb-[10px] md:mb-[20px]">
            <div className="flex gap-xs">
              <img
                src={NDRIcon}
                alt="NDR-icon"
                className="md:w-12 md:h-12 w-8 h-8"
              />
              <Heading
                className="text-[#F62455] text-[18px] md:text-[30px] font-semibold font-secondary"
                Element="h1"
              >
                Hari Kebangsaan 2025
              </Heading>
            </div>
          </div>
        </div>
        <div className="flex gap-[40px]">
          <div
            className={`w-full flex flex-col gap-5 ${geLiveBlog ? "lg:w-[992px] xl:w-[847px]" : ""}`}
          >
            {geLiveBlog && (
              <div className="xl:hidden mx-[10px] lg:mx-0">
                <LiveBlog variant="body" seasonalLiveBlogContent={geLiveBlog} />
              </div>
            )}
            <SeasonalKeywordArticleList
              articles={tagsData}
              adsSectionName={adsSectionName}
            />
          </div>
          {geLiveBlog && (
            <div className="hidden xl:block">
              <LiveBlog
                variant="sidebar"
                seasonalLiveBlogContent={geLiveBlog}
              />
            </div>
          )}
        </div>
      </WidgetWrapper>
    </BHBasePage>
  );
}
